export const tablePl = {
  of: 'z',
  reset: 'Resetuj',
  searchPlaceholder: 'Wyszukaj...',
  savedViews: 'Zapisane widoki',
  saveView: 'Zapisz widok',
  saveInfo: 'Zapisane zostaną: ustawienia tabeli oraz zastosowane filtry.',
  name: 'Nazwa',
  namePlaceholder: 'np. Zamówienia klienta',
  description: 'Opis',
  descriptionPlaceholder: 'Opisz krótko jak działa filtr',
  setAsDefaultView: 'Ustaw jako domyślny widok',
  save: 'Zapisz',
  cancel: 'Anuluj',
  default: 'Domyślny',
  delete: 'Usuń',
  noSavedViews: 'Nie ma jeszcze zapisanych widoków',
  noData: 'Brak danych',
  columnsOrder: 'Układ kolumn',
  columnsOrderSettings: 'Ustawienia listy',
  columnsOrderInfo:
    'Przeciągnij, aby zmienić kolejność kolumn. Ukrywaj (oko) lub przypinaj (pinezka) wybrane elementy. Przypięte kolumny trafiają na górę listy i są zawsze widoczne z lewej strony tabeli.',
  columnsOrderInfoBanner: 'Ustawienie jest przypisywane do zapisanych widoków.',
  overrideCurrentView: 'Nadpisz obecnym widokiem',
  overrideCurrentViewModalHeader: 'Nadpisać zapisany widok?',
  overrideCurrentViewModalDescription:
    'Ustawienia tabeli zostały zmienione. Czy chcesz nadpisać widok <strong>{{name}}</strong> obecnym widokiem?',
  override: 'Nadpisz',
  saveAsNewView: 'Zapisz jako nowy',
  noSearchResults: 'Brak wyników. Zmień kryteria wyszukiwania.',
  moreOptions: 'Więcej opcji',
  advancedFilters: 'Zaawansowane filtry',
  exportToCsv: 'Pobierz CSV',
  csvExportStarted: 'Pobieranie CSV rozpoczęte',
  csvExportSuccess: 'Plik CSV został pobrany pomyślnie',
  csvExportError: 'Nie udało się pobrać pliku CSV',
};

export type TableTranslation = typeof tablePl;
